// Generated by BUCKLESCRIPT, PLEASE EDIT WITH CARE
'use strict';

var Char = require("bs-platform/lib/js/char.js");
var $$Buffer = require("bs-platform/lib/js/buffer.js");
var Format = require("bs-platform/lib/js/format.js");

function equal(a, b) {
  return a === b;
}

function of_int(c) {
  try {
    return Char.chr(c);
  }
  catch (exn){
    return ;
  }
}

function to_int(prim) {
  return prim;
}

function lowercase_ascii(c) {
  if (c > 90 || c < 65) {
    return c;
  } else {
    return c + 32 | 0;
  }
}

function uppercase_ascii(c) {
  if (c > 122 || c < 97) {
    return c;
  } else {
    return c - 32 | 0;
  }
}

var chr = Char.chr;

var escaped = Char.escaped;

var lowercase = Char.lowercase;

var uppercase = Char.uppercase;

var compare = Char.compare;

var of_int_exn = Char.chr;

var pp_buf = $$Buffer.add_char;

var pp = Format.pp_print_char;

exports.chr = chr;
exports.escaped = escaped;
exports.lowercase = lowercase;
exports.uppercase = uppercase;
exports.equal = equal;
exports.compare = compare;
exports.lowercase_ascii = lowercase_ascii;
exports.uppercase_ascii = uppercase_ascii;
exports.of_int_exn = of_int_exn;
exports.of_int = of_int;
exports.to_int = to_int;
exports.pp_buf = pp_buf;
exports.pp = pp;
/* Format Not a pure module */
